import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { IClientTransfer } from "../../models/ClientTransfer";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    contactPerson: number,
    open: boolean,
    company: number,
    hideDialog: () => void,
}

export const TnfrHistory = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IClientTransfer>, loading: boolean });

    useEffect(() => {
        if (props.contactPerson) loadTableData();
    }, [props.contactPerson]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/tnfrHistory", "GET", null, `contactPerson=${props.contactPerson}&company=${props.company}`, null);
        if (response) {
            const data: Array<IClientTransfer> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const previous_Date = (rowData: IClientTransfer) => {
        let date;
        if (rowData.previous_Date) date = format(new Date(rowData.previous_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const transfer_Date = (rowData: IClientTransfer) => {
        let date;
        if (rowData.transfer_Date) date = format(new Date(rowData.transfer_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Client Transfer History" className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="contact_Person_Name" header="Client" />
                <Column field="transfer_From" header="Transfer From" />
                <Column field="transfer_To" header="Transfer To" />
                <Column field="transfer_By" header="Transfer By" />
                {/* <Column field="previous_Date" header="Previous Date" body={previous_Date} />
                <Column field="transfer_Date" header="Transfer Date" body={transfer_Date} /> */}
                <Column field="previous_Date" header="Previous Date" body={(rowData: any) => safeFormatDate(rowData.previous_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="transfer_Date" header="Transfer Date" body={(rowData: any) => safeFormatDate(rowData.transfer_Date, 'dd/MM/yyyy', DateFormat)}/>
            </DataTable>
        </Dialog>
    );
}
